<template>
  <div class="container-xxl about-page py-5">
    <div class="container">
      <section class="about-hero">
        <div>
          <h6 class="section-title text-start text-primary text-uppercase">Hakkımızda</h6>
          <h1>Ankara'da yaşayan Ağrılıları tek çatı altında buluşturuyoruz</h1>
          <p>
            Ankara Ağrılılar Derneği; Ankara Ağrılılar, Doğubayazıtlılar, Patnoslular,
            Diyadinliler, Eleşkirtililer, Tutaklılar, Taşlıçaylılar ve Hamurlular başta
            olmak üzere tüm Ağrı ilçelerinden hemşehrilerimizi dayanışma çatısında bir araya getirir.
            Resmi adımız Başkent Ağrılılar Eğitim Kültür Sosyal Yardımlaşma ve Dayanışma Derneği,
            kütük numaramız 06-158-130’dur.
          </p>
          <div class="about-actions">
            <a href="tel:+905079217404" class="btn btn-dark">
              <i class="fa fa-phone-alt me-2"></i>Derneği Ara
            </a>
            <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
              <i class="fab fa-whatsapp me-2"></i>WhatsApp'a Katıl
            </a>
          </div>
        </div>
        <div class="about-contact-panel">
          <span>Dernek hattı</span>
          <a href="tel:+905079217404"><strong>+90 507 921 74 04</strong></a>
          <small>Ankara Ağrılılar Derneği iletişim hattı. Resmi ad: Başkent Ağrılılar Eğitim Kültür Sosyal Yardımlaşma ve Dayanışma Derneği. Kütük no: 06-158-130.</small>
        </div>
      </section>

      <section class="about-mission-grid">
        <article>
          <i class="fa fa-users"></i>
          <h2>Birlik</h2>
          <p>Ankara'daki Ağrılı aileleri, öğrencileri, esnafları ve çalışanları tanışma ve dayanışma ortamında buluşturuyoruz.</p>
        </article>
        <article>
          <i class="fa fa-hands-helping"></i>
          <h2>Sosyal destek</h2>
          <p>İhtiyaç sahibi hemşehrilerimize, gençlere ve ailelere eğitim, istihdam, danışmanlık ve sosyal destek alanlarında yardımcı oluyoruz.</p>
        </article>
        <article>
          <i class="fa fa-store"></i>
          <h2>Hemşehri ağı</h2>
          <p>Ağrılı firmaları, meslek sahiplerini ve gönüllüleri görünür kılarak Ankara içinde güçlü bir güven ağı kuruyoruz.</p>
        </article>
      </section>

      <section class="about-content">
        <div class="about-text-panel">
          <h2>Ankara Ağrılılar Derneği ne yapar?</h2>
          <p>
            Derneğimiz, ilçe derneklerinin yerine geçmeyi değil; Ankara'daki Ağrı ilçe
            topluluklarını, hemşehri gruplarını ve aileleri ortak bir dayanışma zemini üzerinde
            daha görünür hale getirmeyi hedefler.
          </p>
          <p>
            Ankara'da Ağrı derneği, Ankara Doğubayazıtlılar derneği, Ankara Patnoslular,
            Diyadinliler, Eleşkirtililer, Tutaklılar, Taşlıçaylılar ve Hamurlular gibi aramalarla
            bize ulaşan hemşehrilerimizi doğru iletişim kanallarına yönlendiriyoruz.
          </p>
          <div class="about-check-list">
            <span><i class="fa fa-check"></i>Kültürel etkinlikler ve hemşehri buluşmaları</span>
            <span><i class="fa fa-check"></i>Eğitim, gençlik, istihdam ve kariyer destekleri</span>
            <span><i class="fa fa-check"></i>Esnaf, firma tanıtımı ve ticari dayanışma</span>
            <span><i class="fa fa-check"></i>Taziye, sosyal yardım ve aile destek organizasyonları</span>
          </div>
        </div>

        <aside class="about-stats-panel">
          <div>
            <strong>200+</strong>
            <span>Üye ve gönüllü ağı</span>
          </div>
          <div>
            <strong>20+</strong>
            <span>Etkinlik ve buluşma</span>
          </div>
          <div>
            <strong>{{ DISTRICTS.length }}</strong>
            <span>Ağrı ilçe topluluğu</span>
          </div>
        </aside>
      </section>

      <section class="about-districts">
        <div class="about-section-head">
          <h2>Ağrı ilçeleri Ankara'da ortak çatı altında</h2>
          <p>
            Her ilçemizin kültürü, aile bağı ve dayanışma geleneği farklıdır. Derneğimiz bu
            farklılıkları koruyarak tüm hemşehrilerimizi aynı sofrada buluşturmayı amaçlar.
          </p>
        </div>

        <div class="about-district-grid">
          <router-link
            v-for="district in DISTRICTS"
            :key="district.slug"
            :to="`/ilceler/${district.slug}`"
          >
            <span>{{ district.communityName }}</span>
            <small>{{ district.name }} hemşehrileri</small>
            <i class="fa fa-arrow-right"></i>
          </router-link>
        </div>
      </section>

      <section class="about-seo-text">
        <h2>Ankara'da Ağrılılar için dernek, iletişim ve WhatsApp grubu</h2>
        <p>
          Ankara Ağrılılar Derneği, Başkent Ağrılılar Derneği ve AĞ-DER adıyla bilinen resmi
          dernek adımız Başkent Ağrılılar Eğitim Kültür Sosyal Yardımlaşma ve Dayanışma Derneği'dir.
          Kütük numaramız 06-158-130’dur. Ankara'da yaşayan Ağrılıları, Ağrı merkezlileri,
          Doğubayazıtlıları, Patnosluları, Diyadinlileri, Eleşkirtilileri, Tutaklıları,
          Taşlıçaylıları ve Hamurluları bir araya getiren sosyal, kültürel ve dayanışma odaklı
          bir hemşehri derneğiyiz.
        </p>
      </section>
    </div>
  </div>
</template>

<script setup>
import DISTRICTS from '@/data/districts';

const whatsappJoinUrl = `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`;
</script>

<style scoped>
.about-page {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FAFC 48%, #FFFFFF 100%);
}

.about-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 310px;
  gap: 34px;
  align-items: end;
  margin-bottom: 30px;
}

.about-hero h1 {
  color: var(--dark);
  font-size: clamp(34px, 4.4vw, 58px);
  line-height: 1.06;
  max-width: 930px;
  margin: 0 0 18px;
}

.about-hero p,
.about-section-head p,
.about-seo-text p {
  color: #5B6475;
  font-size: 18px;
  line-height: 1.75;
  margin: 0;
}

.about-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.about-actions .btn {
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  padding: 12px 20px;
}

.about-contact-panel {
  background: var(--dark);
  color: #FFFFFF;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 18px 38px rgba(15, 23, 43, .14);
}

.about-contact-panel span {
  color: var(--primary);
  font-weight: 800;
  text-transform: uppercase;
}

.about-contact-panel strong {
  display: block;
  font-size: 28px;
  margin: 12px 0;
}

.about-contact-panel a {
  color: #FFFFFF;
  display: inline-block;
}

.about-contact-panel a:hover {
  color: var(--primary);
}

.about-contact-panel small {
  color: rgba(255, 255, 255, .76);
  line-height: 1.6;
}

.about-mission-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 30px;
}

.about-mission-grid article,
.about-text-panel,
.about-stats-panel,
.about-districts,
.about-seo-text {
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  box-shadow: 0 12px 30px rgba(15, 23, 43, .06);
}

.about-mission-grid article {
  padding: 24px;
}

.about-mission-grid i {
  color: var(--primary);
  font-size: 30px;
  margin-bottom: 16px;
}

.about-mission-grid h2,
.about-text-panel h2,
.about-section-head h2,
.about-seo-text h2 {
  color: var(--dark);
  font-size: 26px;
  margin-bottom: 12px;
}

.about-mission-grid p,
.about-text-panel p {
  color: #606A7A;
  line-height: 1.7;
  margin: 0;
}

.about-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  gap: 24px;
  margin-bottom: 30px;
}

.about-text-panel,
.about-stats-panel,
.about-districts,
.about-seo-text {
  padding: 28px;
}

.about-text-panel p + p {
  margin-top: 14px;
}

.about-check-list {
  display: grid;
  gap: 10px;
  margin-top: 20px;
}

.about-check-list span {
  display: flex;
  gap: 10px;
  color: #344054;
  font-weight: 600;
}

.about-check-list i {
  color: #1F7A4D;
  margin-top: 4px;
}

.about-stats-panel {
  display: grid;
  gap: 14px;
}

.about-stats-panel div {
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .06);
  border-radius: 8px;
  padding: 18px;
}

.about-stats-panel strong {
  display: block;
  color: var(--primary);
  font-size: 38px;
  line-height: 1;
}

.about-stats-panel span {
  color: var(--dark);
  font-weight: 700;
}

.about-districts {
  margin-bottom: 30px;
}

.about-section-head {
  max-width: 860px;
  margin-bottom: 22px;
}

.about-district-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.about-district-grid a {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 5px 10px;
  align-items: center;
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 3px solid var(--primary);
  border-radius: 8px;
  padding: 16px;
}

.about-district-grid span {
  color: var(--dark);
  font-weight: 800;
}

.about-district-grid small {
  color: #667085;
  grid-column: 1;
}

.about-district-grid i {
  color: var(--primary);
  grid-row: 1 / span 2;
  grid-column: 2;
}

.about-district-grid a:hover {
  background: #FFF4DF;
}

@media (max-width: 991.98px) {
  .about-hero,
  .about-content,
  .about-mission-grid {
    grid-template-columns: 1fr;
  }

  .about-district-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 575.98px) {
  .about-page {
    padding-bottom: 86px !important;
  }

  .about-hero h1 {
    font-size: 32px;
  }

  .about-hero p,
  .about-section-head p,
  .about-seo-text p {
    font-size: 16px;
  }

  .about-actions .btn {
    width: 100%;
    justify-content: center;
  }

  .about-district-grid {
    grid-template-columns: 1fr;
  }
}
</style>
